import React from 'react';
import Subtitle from '../../shared/Subtitle'
import Code from '../../shared/Code'

export function JS({codeLang}) {

    switch(codeLang) {
        case 'http': return <Code lang="javascript">
                {`
Authorization signmage mBS73C5TdTjthjF0:HMAC
Content-Type application/json
GET /api/report/
                `}
                </Code>
        case 'python': return <Code lang="javascript">
                {`
from signmage import SignmageServices

webid = "mBS73C5TdTjthjF0"
apikey = "521026f468b9dadc2419e476356934d0"

services = SignmageServices(webid, apikey)
data = services.request({
"url_doc":"https://firmamex.com/pdf/simple/default"
})
                `}
                </Code>
        default: return <Code lang="javascript">
{`
const FirmamexServices = require('./firmamex');
const services = FirmamexServices('mBS73C5TdTjthjF0', "521026f468b9dadc2419e476356934d0");

const response = await services.getReport('5b31583e ac48-4bb3-8066-5a84c648bdad')

`}
        </Code>
    }
}

export function Response() {
    return <Code lang="javascript">
        {
`{
    "InkSignatures": [],
    "firmas": [{
            "page": 1,
            "left": 189.3,
            "top": 594.6,
            "width": 200.99998,
            "height": 42.599976,
            "downstream": false,
            "campoFirma": "1",
            "coversDocument": false,
            "revision": 1,
            "totalRevisions": 2,
            "validSignature": true,
            "signDate": "Tue May 09 12:26:44 GMT-07:00 2023",
            "reason": "",
            "ipAddress": "0:0:0:0:0:0:0:1",
            "timestampAuthority": "C=CA,ST=Ontario,L=Ottawa,O=Entrust\\, Inc.,CN=Entrust Timestamp Authority - TSA1",
            "certType": "EMAIL",
            "signCertificateSerial": "-63ce4e8552b71b338981f6781866912cb691033b",
            "ocsp": {
                "signatureValid": true,
                "certStatus": "good",
                "signer": "Autoridad de Certificacion por Correo de Firmamex"
            },
            "certificados": [{
                    "commonName": "siestacephei472@gmail.com",
                    "country": null,
                    "email": "siestacephei472@gmail.com",
                    "location": null,
                    "organization": null,
                    "serial": "-63ce4e8552b71b338981f6781866912cb691033b",
                    "signatureAlgorithm": "SHA256WITHRSA",
                    "issuerCommonName": "Autoridad de Certificacion por Correo de Firmamex",
                    "issuerCountry": "US",
                    "issuerEmail": "certificate.authority@signmage.com",
                    "issuerLocation": "Autoridad de Certificacion por Correo de Firmamex",
                    "issuerOrganization": "Signmage\\, Inc.",
                    "expirationDate": "Thu May 09 09:42:19 GMT-07:00 2024",
                    "validationDate": "Tue May 09 09:42:19 GMT-07:00 2023",
                    "hexCertificado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
                    "publicKey": "RSA Public Key [64:4d:4a:31:54:fa:38:be:1b:37:70:f3:64:21:e6:ff:af:a1:4c:f9],[56:66:d1:a4]        modulus: 9404f3a2d49e11ad4931b14a6e77f168f3623ecea336084cb75f8220314073f95bf3adb2992a9db07b86fc0b189dc03380ffc030d370d4468ad9da79f552fa544512fb081e3a0679fd6b7047062d99a305012f13448b3304df5a69543bf3a971d7b6060cc3d1ff7bc761c89b3fcad2a47e621d37a2172eaa0db543f3eedb1356f5a7ab8814cee7cb665160a1bf5c599dd4b69d5c57ff88a0c40089230c6b4020899d1350922df12f56088bb613ea176616ab37aeca0910082577ee56989a8d581180df4081573aa297a4e952980192c4fc64eb1358ca16e886e2eec505eb26cfd6b332d0516f389795334c42df5eff261d97d5a94db1dc9355fa899e61f2efebpublic exponent: 10001"
                }, {
                    "commonName": "Autoridad de Certificacion por Correo de Firmamex",
                    "country": "US",
                    "email": "certificate.authority@signmage.com",
                    "location": "Sunnyvale",
                    "organization": "Signmage\\, Inc.",
                    "serial": "af8ba4a2163f2a53",
                    "signatureAlgorithm": "SHA256WITHRSA",
                    "issuerCommonName": "Autoridad de Certificacion por Correo de Firmamex",
                    "issuerCountry": "US",
                    "issuerEmail": "certificate.authority@signmage.com",
                    "issuerLocation": "Autoridad de Certificacion por Correo de Firmamex",
                    "issuerOrganization": "Signmage\\, Inc.",
                    "expirationDate": "Sat Nov 30 17:07:21 GMT-07:00 2047",
                    "validationDate": "Thu Dec 07 17:07:21 GMT-07:00 2017",
                    "hexCertificado": "308204923082037AA003020102020900AF8BA4A2163F2A53300D06092A864886F70D01010B05003081DD310B3009060355040613025553310B300906035504080C0243413112301006035504070C0953756E6E7976616C6531173015060355040A0C0E5369676E6D6167652C20496E632E31253023060355040B0C1C5369676E6D616765205472757374776F72746879204E6574776F726B313A303806035504030C314175746F72696461642064652043657274696669636163696F6E20706F7220436F7272656F206465204669726D616D65783131302F06092A864886F70D010901162263657274696669636174652E617574686F72697479407369676E6D6167652E636F6D301E170D3137313230383030303732315A170D3437313230313030303732315A3081DD310B3009060355040613025553310B300906035504080C0243413112301006035504070C0953756E6E7976616C6531173015060355040A0C0E5369676E6D6167652C20496E632E31253023060355040B0C1C5369676E6D616765205472757374776F72746879204E6574776F726B313A303806035504030C314175746F72696461642064652043657274696669636163696F6E20706F7220436F7272656F206465204669726D616D65783131302F06092A864886F70D010901162263657274696669636174652E617574686F72697479407369676E6D6167652E636F6D30820122300D06092A864886F70D01010105000382010F003082010A0282010100CA0B9FBC497F8D324C401839309445F28A7BCB3AEECC9D78EA5B85F7999B7A2AE4F632D220579D4BE8A124327909D6C72A9986717CB03C11F4068043ADFEF3DCD72A7710B8F08F73D9AE6A564AE555C977512BA1229D12A2B2DB837D79F9B9E87A758CA476F5B1466201BF1BDDAD68AFD48AE4E894C7F7C51509954B8E999CB45CE00E71FFF0804DA8119E1F9A584EA0AD50632D40AFA3713ED24CF03AA9FCD6F8B7AA76E90C97AD6B25C426ADA897A97BBBF4DAD498583C104C910FCD8417CD6F7A3E352889B7BE6AFE4835E323DFECA343FBCE7428470EFEF6E7A00544C4E491106D7E3D84B90AF347154CDF228A3C20B2806567D0646644980FF3D56E27090203010001A3533051301D0603551D0E04160414701B13EBECAA335FF6082E7E4AB77316EAF6C0FA301F0603551D23041830168014701B13EBECAA335FF6082E7E4AB77316EAF6C0FA300F0603551D130101FF040530030101FF300D06092A864886F70D01010B05000382010100AABA932AD21A929EC28FEB8667F3F94ADAF1A2C987E50433DC14A630A6E017367F2290AE314A80C939A057BD75449E3630698346480B66206235A1F30E16F8469B85FF5C0D4DD44F1D61E6E303E4FA78162876998DFE6BCA186F630FB3148FA7690F076379DDA65E0C40FDFDE288FF1D2B2D49D9404D3C1101BC97589CEA931F7FB6DF94A124830877459BA440C862B76D9B90E7949DED3E6CD602005F0F2A1268F23E855663698E941ABA2C6AAED7F6FE377DDC0FF6FA60F2C36BF3F08E83ECF7A7B043F11EAE9F3D333961D76DEAC4D601CBE61FF4329549513929FB4CE39269C044A3783D8CF6ADD573E7615ADAFE76F82553F0B9B853BE15C1FF09532A35",
                    "publicKey": "RSA Public Key [53:95:0f:da:fd:7a:f2:75:66:83:3e:5f:c1:9a:8c:52:20:cb:27:60],[56:66:d1:a4]        modulus: ca0b9fbc497f8d324c401839309445f28a7bcb3aeecc9d78ea5b85f7999b7a2ae4f632d220579d4be8a124327909d6c72a9986717cb03c11f4068043adfef3dcd72a7710b8f08f73d9ae6a564ae555c977512ba1229d12a2b2db837d79f9b9e87a758ca476f5b1466201bf1bddad68afd48ae4e894c7f7c51509954b8e999cb45ce00e71fff0804da8119e1f9a584ea0ad50632d40afa3713ed24cf03aa9fcd6f8b7aa76e90c97ad6b25c426ada897a97bbbf4dad498583c104c910fcd8417cd6f7a3e352889b7be6afe4835e323dfeca343fbce7428470efef6e7a00544c4e491106d7e3d84b90af347154cdf228a3c20b2806567d0646644980ff3d56e2709public exponent: 10001"
                }
            ]
        }
    ],
    "certificationLevel": 0,
    "document": {
        "name": "Comenzar",
        "author": "",
        "createdAt": 1683660349000,
        "updatedAt": 1683660404000
    },
    "metaData": {},
    "documentStatus": {},
    "ticket": "02ce70d4-d4a2-4b0d-879c-bcf44b237471",
    "fileDigest": "eZVoLKWbf5ZyQ1Q4N7pL6W7+rmewU+ENQACfeYbImog=",
    "originalName": "Comenzar",
    "signmage": true,
    "signable": true,
    "haveForm": false,
    "ownerId": 1328,
    "userId": 1497,
    "withQR": false,
    "hasAttachments": false
}
`
        }
    </Code>
}

export function html() {
    return (
        <React.Fragment>
            <Subtitle>Información del documento</Subtitle>
            <div className="Content">
                <p>
                    Puedes consultar en cualquier momento el estatus de un documento (además de las notificaciones
                    que recibirás cuando se firme un documento).
                </p>
                </div>
        </React.Fragment>
    )
}

export default { JS, html, Response }